import { Button } from '@mui/material'
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined'
import { useOnboarding } from '../../context/onboardingGuideContext'

/**
 * Header Guide control for Layer B surface guides.
 */
export function PageGuideButton({ surfaceId, label = 'Guide' }) {
  const { openSurfaceGuide, isSurfaceGuideAvailable } = useOnboarding()

  if (!surfaceId || !isSurfaceGuideAvailable(surfaceId)) return null

  return (
    <Button
      size="small"
      variant="outlined"
      color="inherit"
      startIcon={<MenuBookOutlinedIcon fontSize="small" />}
      onClick={() => openSurfaceGuide(surfaceId)}
      sx={{ flexShrink: 0, textTransform: 'none', fontWeight: 600 }}
    >
      {label}
    </Button>
  )
}
